import PlatformLayout from "../../src/platform/layout/PlatformLayout";
import { PlatformHead } from "../../src/platform/layout/PlatformHead";
import { linksConstants } from "../../src/constants/linksConstants";
import { CreateDataAPI } from "../../src/platform/views/UseCases/CreateDataAPI";

const CreateApiPage = () => {
  return (
    <>
      <PlatformHead currentPath={linksConstants.CREATE_DATA_API} title="Create Data API" />
      <PlatformLayout isAuthRequired>
        <CreateDataAPI />
      </PlatformLayout>
    </>
  );
};

export default CreateApiPage;
